// src/components/DietaryLabel.tsx
import React from 'react';
import { Chip, Box, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';

export interface DietaryInfo {
    isVegan: boolean;
    isVegetarian: boolean;
    isHalal: boolean;
    isKosher: boolean;
    isFast: boolean;
}

interface DietaryLabelProps {
    dietaryInfo: DietaryInfo;
}

const DietaryLabel: React.FC<DietaryLabelProps> = ({ dietaryInfo }) => {
    const { t } = useTranslation();

    const dietaryLabels = [
        { key: 'isVegan', label: 'Vegan', color: '#4CAF50', textColor: 'white' },
        { key: 'isVegetarian', label: 'Vegetarian', color: '#8BC34A', textColor: 'black' },
        { key: 'isHalal', label: 'Halal', color: '#2196F3', textColor: 'white' },
        { key: 'isKosher', label: 'Kosher', color: '#3F51B5', textColor: 'white' },
        { key: 'isFast', label: 'Fast', color: '#FF9800', textColor: 'black' },
    ] as const;

    return (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mt: 1 }}>
            {dietaryInfo && dietaryLabels.map(({ key, label, color, textColor }) => (
                dietaryInfo[key as keyof DietaryInfo] && (
                    <Tooltip key={key} title={t(`dietary.${key}.description`)} arrow>
                        <Chip
                            label={t(`dietary.${key}.label`)}
                            size="small"
                            sx={{
                                backgroundColor: color,
                                color: textColor,
                                fontSize: '0.75rem',
                                height: 24,
                                '& .MuiChip-label': {
                                    px: 1,
                                }
                            }}
                        />
                    </Tooltip>
                )
            ))}
        </Box>
    );
};

export default DietaryLabel;